export const toIsoDate = (d) => {
  const dt = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  return dt.toISOString().slice(0, 10);
};

export const makeDefaultDateRange21 = () => {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 20); 
  return { start: toIsoDate(start), end: toIsoDate(today) };
};
